export const GET_ALL_PLAYLIST_DATA = 'GET_ALL_PLAYLIST_DATA';
export const GET_ALL_PLATFORM_DATA = 'GET_ALL_PLATFORM_DATA';
export const GET_ALL_OCCASSION_DATA = 'GET_ALL_OCCASSION_DATA';


